var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusColor)?_c('c-chip',{staticClass:"declare-ticket-rule-ticket-status-chip px-2",attrs:{"color":_vm.statusColor,"text-color":_vm.textColor,"small":""}},[_c('strong',[_vm._v(_vm._s(_vm.statusText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }